/**
 * Global JavaScript utilities
 * Author: Michael Benjamin Crowe
 */

window.theme = window.theme || {};

theme.utils = {
  debounce: function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  throttle: function(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  },

  formatMoney: function(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    const money = Math.round(cents / 100).toLocaleString('en-PK');
    const moneyFormat = format || window.theme?.moneyFormat || 'Rs. {{amount}}';
    return moneyFormat.replace(/\{\{\s*amount\w*\s*\}\}/g, money);
  },

  getUrlParameter: function(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};
// Performance: Debounced window resize helper
window.GharMartDebounce = function(fn, delay) {
  var timer = null;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() { fn.apply(context, args); }, delay || 150);
  };
};

// A11y: Trap focus helper for accessible modals
window.GharMartTrapFocus = function(container) {
  if (!container) return;
  var focusable = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable.length) focusable[0].focus();
};
